export default "__VITE_ASSET__5reaV$Fm__"